import {
  FETCH_RESERVATION_TYPES,
  FETCH_CUSTOMERS,
  CREATE_MATCHER_FOR_DISPLAY,
  SET_MATCH_FIELD,
  VALID_MATCHER,
  CLEAR_MATCH_FIELD,
  CHOOSE_DATE_TIME_FORMAT,
  STORE_TZ,
  FETCH_RESERVATION_TYPES_ACTION,
  TRANSFORM_DATA_ACTION,
  CLEAR_TIMEZONE,
  CLEAR_MATCH_FIELDS_DATA
} from '@/system/store/action-types'
import {
  SET_RESERVATION_TYPES,
  SET_MATCHER_ITEM,
  SET_MATCHER_FOR_DISPLAY,
  CLEAR_SELECT_MATCH_FIELD,
  SET_ISSUES_AN_IS_VALID,
  SET_DATE_TIME_FORMAT,
  SET_SELECTED_TZ,
  CLEAR_MATCH_DATA
} from '@/system/store/mutation-types'
import {
  ERROR
} from '@/constants'
import { IMatchFieldsStore, IIssue, IMatchFieldsOption, IMatchFieldsSendOption, IMatcherItem, ITransformPayload } from '@/features/matchFields/store'

import { ValidationService } from '@/features/matchFields/matchField.service'

import { Action, ActionTree, ActionContext, Commit } from 'vuex'
import WebSocketService from '@/system/socket/socket.service'

const maxRetries = 1
let retries: number = 0

const matchFieldsService = new WebSocketService()

const fetchReservationType: Action<IMatchFieldsStore, any> = (context: { commit: Commit }, options: any) => {
  const { action, ...types } = options
  return context.commit(SET_RESERVATION_TYPES, types)
}

const createMatcherForDisplay: Action<IMatchFieldsStore, any> = (context: { commit: Commit, rootState: any }, sample: any) => {
  const [firstSampleElement] = sample
  const { originallyOrderedHeader = [] } = context.rootState?.job?.job?.meta
  const orderedTemplate = originallyOrderedHeader.reduce((acc: any, h: string) => ({ ...acc, [h]: null }), {})
  const columns = Object.entries({
    ...orderedTemplate,
    ...firstSampleElement
  }).map(([k, v]) => {
    return {
      column: k,
      sampleValue: v,
      assignedField: null
    }
  })

  return context.commit(SET_MATCHER_FOR_DISPLAY, columns)
}

const setMatchField: Action<IMatchFieldsStore, any> = (context: { commit: Commit }, options: IMatchFieldsOption) => {
  const { item, value } = options
  const { column, sampleValue } = item
  const matcherItem: IMatcherItem = {
    column,
    sampleValue,
    assignedField: { [value]: column }
  }

  return context.commit(SET_MATCHER_ITEM, matcherItem)
}

const validMatcher: Action<IMatchFieldsStore, any> = (context: ActionContext<IMatchFieldsStore, any>, options: IMatchFieldsSendOption) => {
  const { matcher, matcherForDisplay, dateTimeFormat } = options
  const validationService = new ValidationService()
  let { issues }: { issues: IIssue[] } = validationService.validate({ matcher, matcherForDisplay, dateTimeFormat })

  const hasErrors = issues.some(({ type }: { type: string }) => type === ERROR)

  if (hasErrors) retries = 0
  if (issues.length && !hasErrors) retries += 1
  if (retries > maxRetries || !issues.length) {
    retries = 0
    return context.commit(SET_ISSUES_AN_IS_VALID, { issues, isValid: true })
  }

  return context.commit(SET_ISSUES_AN_IS_VALID, { issues, isValid: false })
}

const clearMatchField: Action<IMatchFieldsStore, any> = (context: { commit: Commit }, { value }: any) => {
  return context.commit(CLEAR_SELECT_MATCH_FIELD, { value })
}

const storeDateTimeFormat: Action<IMatchFieldsStore, any> = (context: { commit: Commit }, dateTimeFormat: string) => {
  return context.commit(SET_DATE_TIME_FORMAT, dateTimeFormat)
}

const clearTimezone: Action<IMatchFieldsStore, any> = (context: { commit: Commit }) => {
  return context.commit(SET_SELECTED_TZ, '')
}

const clearMatchFieldsData: Action<IMatchFieldsStore, any> = (context: { commit: Commit }) => {
  return context.commit(CLEAR_MATCH_DATA)
}

const storeTz: Action<IMatchFieldsStore, any> = (context: { commit: Commit }, tz: string = '') => {
  return context.commit(SET_SELECTED_TZ, tz)
}

const fetchReservationTypesAction: Action<IMatchFieldsStore, any> = (context: { commit: Commit }) => {
  return matchFieldsService.fetchReservationTypes()
}

const fetchCustomersAction: Action<IMatchFieldsStore, any> = (context: { commit: Commit }) => {
  return matchFieldsService.fetchCustomers()
}

const transformDataAction: Action<IMatchFieldsStore, any> = (context: { commit: Commit }, payload: ITransformPayload) => {
  return matchFieldsService.transformData({ payload })
}

const actions: ActionTree<IMatchFieldsStore, any> = {
  [FETCH_RESERVATION_TYPES]: fetchReservationType,
  [FETCH_CUSTOMERS]: fetchCustomersAction,
  [CREATE_MATCHER_FOR_DISPLAY]: createMatcherForDisplay,
  [SET_MATCH_FIELD]: setMatchField,
  [VALID_MATCHER]: validMatcher,
  [CLEAR_MATCH_FIELD]: clearMatchField,
  [CHOOSE_DATE_TIME_FORMAT]: storeDateTimeFormat,
  [STORE_TZ]: storeTz,
  [FETCH_RESERVATION_TYPES_ACTION]: fetchReservationTypesAction,
  [TRANSFORM_DATA_ACTION]: transformDataAction,
  [CLEAR_TIMEZONE]: clearTimezone,
  [CLEAR_MATCH_FIELDS_DATA]: clearMatchFieldsData
}

export default actions
